if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this._carouselInitialized) return;
        this._carouselInitialized = true;
        super.connectedCallback();
        this.setupCarousel();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      setupCarousel() {
        this.prevButton = this.querySelector("[data-product-media-prev]");
        this.nextButton = this.querySelector("[data-product-media-next]");

        this.prevButton?.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.changeActiveMedia(-1);
        });
        this.nextButton?.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.changeActiveMedia(1);
        });

        this.addEventListener("keydown", (event) => {
          if (event.key === "ArrowRight") {
            event.preventDefault();
            this.changeActiveMedia(1);
          }

          if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.changeActiveMedia(-1);
          }
        });
      }

      showActiveMedia(mediaId = null) {
        const mediaItems = Array.from(
          this.querySelectorAll(
            ".product-media-modal__content > [data-media-id]",
          ),
        );
        if (!mediaItems.length) return;

        const targetMediaId =
          mediaId || this.openedBy?.getAttribute("data-media-id");
        let activeMedia = mediaItems[0];

        if (targetMediaId) {
          activeMedia =
            mediaItems.find(
              (element) =>
                element.getAttribute("data-media-id") === targetMediaId,
            ) || mediaItems[0];
        } else {
          const currentActive = this.querySelector(
            ".product-media-modal__content > .active",
          );
          if (currentActive) {
            activeMedia = currentActive;
          }
        }

        mediaItems.forEach((element) => {
          element.classList.remove("active");
          element.setAttribute("aria-hidden", "true");
        });

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.setAttribute("aria-hidden", "false");
        activeMedia.scrollIntoView({ block: "nearest", inline: "center" });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = Math.max(
            0,
            (activeMedia.offsetWidth - container.clientWidth) / 2,
          );
        }

        this.currentMediaId = activeMedia.getAttribute("data-media-id");
        this.updateNavigationState();

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }

      changeActiveMedia(step) {
        const mediaItems = Array.from(
          this.querySelectorAll(
            ".product-media-modal__content > [data-media-id]",
          ),
        );
        if (!mediaItems.length) return;

        const currentIndex = mediaItems.findIndex((item) =>
          item.classList.contains("active"),
        );
        const nextIndex =
          currentIndex >= 0
            ? (currentIndex + step + mediaItems.length) % mediaItems.length
            : 0;
        const nextMedia = mediaItems[nextIndex];
        if (nextMedia) {
          this.showActiveMedia(nextMedia.getAttribute("data-media-id"));
        }
      }

      updateNavigationState() {
        if (!this.prevButton || !this.nextButton) return;
        const mediaItems = Array.from(this.querySelectorAll("[data-media-id]"));
        const hasMultipleMedia = mediaItems.length > 1;
        this.prevButton.toggleAttribute("disabled", !hasMultipleMedia);
        this.nextButton.toggleAttribute("disabled", !hasMultipleMedia);
      }
    },
  );
}
